import React from 'react';
import Styles from '../../../../../stylesheet/css/header-builder/icons/desktop.css';
import stylesDevice from '../../../../../stylesheet/css/header-builder/devices-link.css';

const Desktop = (props) => (
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="25px" height="20px" viewBox="0 0 25 20" xmlSpace="preserve" fill="#a6a6a6">
    <g>
      <g>
        <path className={`st0 ${stylesDevice.svgPath}`} d="M23,0H2C0.9,0,0,0.9,0,2v12c0,1.1,0.9,2,2,2h9.5v2H8c-0.6,0-1,0.4-1,1s0.4,1,1,1h9c0.6,0,1-0.4,1-1 s-0.4-1-1-1h-3.5v-2H23c1.1,0,2-0.9,2-2V2C25,0.9,24.1,0,23,0z"/>
      </g>
    </g>
  </svg>
);

export default Desktop;


// WEBPACK FOOTER //
// ./app/header-builder/components/icons/Desktop.js